(() => {
  const promoFromUrl = new URLSearchParams(window.location.search).get('promo');
  if (promoFromUrl) {
    const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
    document.cookie = `promo=${encodeURIComponent(promoFromUrl)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  }

  function currentPromo() {
    if (promoFromUrl) return promoFromUrl;
    const cookie = document.cookie.split(';').find((entry) => entry.trim().startsWith('promo='));
    const value = cookie?.trim().slice('promo='.length) || '';
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }

  // ponytail: browser-only state; use server identity for cross-device recognition or unsubscribe sync.
  const newsletterCookie = 'vo_newsletter_subscribed=true';
  const pendingNewsletterKey = 'vo-newsletter-pending';
  const hasNewsletterCookie = () => document.cookie.split(';').some((entry) => entry.trim() === newsletterCookie);
  let newsletterSubscribed = hasNewsletterCookie();

  function rememberNewsletterSubscription() {
    newsletterSubscribed = true;
    try {
      const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
      document.cookie = `${newsletterCookie}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
    } catch {
      // Keep the current page eligible when browser storage is unavailable.
    }
  }

  // Read the server result before section markers can remove a newsletter form.
  try {
    const pending = sessionStorage.getItem(pendingNewsletterKey) === 'true';
    sessionStorage.removeItem(pendingNewsletterKey);
    if (pending && document.querySelector('[data-vo-newsletter-posted="true"]')) {
      rememberNewsletterSubscription();
    }
  } catch {
    // An unconfirmed submission must not change the audience.
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const tags = form.querySelector('input[name="contact[tags]"]')?.value || '';
    try {
      if (tags.split(',').some((tag) => tag.trim() === 'newsletter') && form.checkValidity()) {
        sessionStorage.setItem(pendingNewsletterKey, 'true');
      } else {
        sessionStorage.removeItem(pendingNewsletterKey);
      }
    } catch {
      // Storage restrictions must not prevent the form from submitting.
    }
  }, true);

  window.addEventListener('newsletter:success', () => {
    if (newsletterSubscribed) return;
    rememberNewsletterSubscription();
    if (hasNewsletterCookie()) window.location.reload();
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted && newsletterSubscribed !== hasNewsletterCookie()) window.location.reload();
  });

  class ContentScheduling extends HTMLElement {
    static dateBoundary(value, end) {
      const match = /^(\d{4}-\d{2}-\d{2})(?:[ T](\d{2}:\d{2})(?::(\d{2}))?)?$/.exec(value.trim());
      if (!match) return null;
      const time = match[2] ? `${match[2]}:${match[3] || '00'}` : end ? '23:59:59' : '00:00:00';
      const iso = `${match[1]}T${time}.000Z`;
      const date = new Date(iso);
      if (!Number.isFinite(date.getTime()) || date.toISOString() !== iso) return null;
      return `${match[1]} ${time}`;
    }

    static dateBetween(timezone, start, end) {
      if (!start && !end) return true;
      const from = start ? this.dateBoundary(start, false) : null;
      const to = end ? this.dateBoundary(end, true) : null;
      if ((start && !from) || (end && !to)) return false;

      try {
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: timezone || 'UTC',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
        }).formatToParts(new Date());
        const date = Object.fromEntries(parts.map((part) => [part.type, part.value]));
        const now = `${date.year}-${date.month}-${date.day} ${date.hour}:${date.minute}:${date.second}`;
        return (!from || now >= from) && (!to || now <= to);
      } catch {
        return false;
      }
    }

    static isVisible(data) {
      if (!this.dateBetween(data.timezone, data.dateFrom, data.dateTo)) return false;
      const loggedIn = Boolean(data.customer) || newsletterSubscribed;
      const loggedRequired = data.loggedRequired === 'true';
      const campaignRequired = data.utmRequired === 'true';
      if (data.notLoggedRequired === 'true' && (loggedIn || loggedRequired)) return false;

      const promo = currentPromo();
      const matchesPromo = Boolean(promo) && (data.utmId || '').split(',').some((id) => id.trim() === promo)
        && this.dateBetween(data.utmTimezone, data.utmDateFrom, data.utmDateTo);
      if (data.utmNotRequired === 'true' && (matchesPromo || campaignRequired)) return false;
      return (!loggedRequired && !campaignRequired)
        || (loggedRequired && loggedIn)
        || (campaignRequired && matchesPromo);
    }

    connectedCallback() {
      if (!this.isConnected) return;
      const target = this.dataset.targetId
        ? this.closest(`#${CSS.escape(this.dataset.targetId)}`)
        : this;
      if (!target) return;

      if (!ContentScheduling.isVisible(this.dataset)) {
        target.remove();
      } else if (target !== this) {
        // Removing the marker also removes the temporary hiding style.
        this.remove();
      } else {
        this.style.display = this.dataset.typeDisplay || 'block';
      }
    }
  }

  if (!customElements.get('content-scheduling')) {
    customElements.define('content-scheduling', ContentScheduling);
  }
})();
